export enum User {
  Breeder = 'breeder',
  Buyer = 'buyer',
  ServiceProvider = 'service provider',
}
